import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { IProps } from './types';
import commonService from 'utils/commonService';

const MergeTable: React.FC<IProps> = (props) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [tableElemHeight, setTableElemHeight] = useState(0);
  const resources = useSelector((state: RootReducersState) => state.resources);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line
  }, []);

  /**
   * @description 偵測分頁大小變動，更新表格高度
   * @param event event object
   */
  const handleResize = (event: any) => {
    const tableElemHeight = (props.detailOpen && tableRef && tableRef.current) ? tableRef.current.clientHeight : 0;
    setTableElemHeight(tableElemHeight);
  };

  /**
   * @description 更新表格高度
   */
  useEffect(() => {
    const tableElemHeight = (props.detailOpen && tableRef && tableRef.current) ? tableRef.current.clientHeight : 0;
    setTableElemHeight(tableElemHeight);
  }, [props.detailOpen, props.DATA]);

  return (
    <div className="insured-content__merge-table" style={{ height: tableElemHeight }}>
      <div ref={tableRef}>
        <table>
          <tbody>
            <tr className="insured-content__table-title">
              {props.DATA.header.map((it, index) => {
                const style = {
                  width: it.width
                };
                const title = commonService.getNameByLng(resources, it.tid);
                return (
                  <th colSpan={it.colSpan ?? 1} style={style} key={`title-${index}`}>{it.tid ? (title ?? it.fieldText) : it.fieldText}</th>
                );
              })}
            </tr>
            {props.DATA.rows.length > 0 && props.DATA.rows.map((row, rowIndex) => {
              return (
                <tr key={`row-${rowIndex}`}>
                  {row.columns.map((col, colIndex) => {
                    if (col.rowSpan === 0 || col.colSpan === 0) return null;
                    return (
                      <td rowSpan={col.rowSpan} colSpan={col.colSpan} className={col.className + (colIndex > 0 ? ' left-border' : '')} key={`col-${rowIndex}-${colIndex}`}>
                        {col.fieldValue}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            <tr>
              <td className="total" colSpan={props.DATA.header.map(item => item.colSpan || 1).reduce((acc, cur) => acc + cur, 0)}>{`${commonService.getNameByLng(resources, 'TID_Premium_Total')}：NT$ ${props.TOTAL_FEE} ${commonService.getPriceUnitByLng(resources)}`}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MergeTable;
